import { combineReducers } from "redux";
import Common from "./Common";
import Auth from "./Auth";
import Cart from "./Cart";
import Checkout from "./Checkout";
import Shopify from "./Shopify";
import User from "./User";

export default combineReducers({
  common: Common,
  auth: Auth,
  user: User,
  cart: Cart,
  checkout: Checkout,
  shopify: Shopify,
});
